import React from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import { generateUrl } from "Services/withDefaultParams";
import { Col } from "ComponentsUI/Styles/Grid";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import BenefitDefault from "ComponentsUI/Benefit/Components/BenefitDefault";
import BenefitCategory from "ComponentsUI/Benefit/Components/BenefitCategory";
import withStyles from "react-jss";
var Routes = require("Configs/routes");

const wrapperStyle = (theme) => ({
	root: {
		paddingBottom: "0",
		transform: "translateY(-90px)",
		display: "flex",
		justifyContent: "flex-start",
		flexWrap: "wrap",
		alignItems: "stretch",
		marginRight: "-20px",
		marginBottom: "-90px !important",
	},
	[`@media (min-width: ${theme.media.sm})`]: {
		root: {
			margin: "0 auto",
			padding: "0",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			paddingBottom: "0",
			transform: "translateY(-40px)",
			marginRight: "-10px",
			marginBottom: "-40px !important",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			display: "none",
		},
	},
});

const Wrapper = withStyles(wrapperStyle)(({ children, classes }) => {
	return <div className={classes.root}>{children}</div>;
});

@withRouter
@inject("ApplicationModel")
@observer
export default class BusinessBenefitsContainer extends React.Component {
	onConnectSmallBusiness() {
		let orderToOfficeUrl = generateUrl(Routes.Business.route, {
			regionUrl: this.props.match.params.regionUrl,
		});
		this.props.history.push(orderToOfficeUrl);
	}

	onConnectMediumBusiness() {
		let orderToOfficeUrl = generateUrl(Routes.Business.route, {
			regionUrl: this.props.match.params.regionUrl,
		});
		this.props.history.push({
			pathname: orderToOfficeUrl,
			search: "place=1",
		});
	}

	onConnecBigBusiness() {
		let orderToOfficeUrl = generateUrl(Routes.Business.route, {
			regionUrl: this.props.match.params.regionUrl,
		});
		this.props.history.push({
			pathname: orderToOfficeUrl,
			search: "place=2",
		});
	}
	render() {
		const {
			ApplicationModel: { text },
		} = this.props;
		return (
			<Wrapper>
				<Container>
					<Row>
						<Col xs={12} sm={4} lg={4} md={4}>
							<BenefitDefault
								header={text.BUSINESS_BENEFIT_MAIN_PAGE_TITLE_1}
								text={text.BUSINESS_BENEFIT_MAIN_PAGE_TEXT_1}
								icon={
									<span
										style={{
											fontSize: "48px",
											color: "#cf0",
										}}
										className="icon48 icon-balance"
									/>
								}
								backgroundColor={"purple"}
								yellowTheme={true}
							/>
						</Col>
						<Col xs={12} sm={4} lg={4} md={4}>
							<BenefitDefault
								header={text.BUSINESS_BENEFIT_MAIN_PAGE_TITLE_2}
								text={text.BUSINESS_BENEFIT_MAIN_PAGE_TEXT_2}
								icon={
									<span
										style={{
											fontSize: "48px",
											color: "#cf0",
										}}
										className="icon48 icon-flash-2"
									/>
								}
								backgroundColor={"purple"}
								yellowTheme={true}
							/>
						</Col>
						<Col xs={12} sm={4} lg={4} md={4}>
							<BenefitDefault
								header={text.BUSINESS_BENEFIT_MAIN_PAGE_TITLE_3}
								text={text.BUSINESS_BENEFIT_MAIN_PAGE_TEXT_3}
								icon={
									<span
										style={{
											fontSize: "48px",
											color: "#cf0",
										}}
										className="icon48 icon-network"
									/>
								}
								backgroundColor={"purple"}
								yellowTheme={true}
							/>
						</Col>
					</Row>
					<Row>
						<Col xs={12} sm={4} lg={4} md={4}>
							<BenefitCategory
								header={text.BUSINESS_BENEFIT_TO_OFFICE_TITLE}
								text={text.BUSINESS_BENEFIT_TO_OFFICE_TEXT}
								category={text.heroInternet}
								datatest="business_inoffice_button"
								icon={
									<span
										style={{
											fontSize: "48px",
											color: "#5812fe",
										}}
										className="icon48 icon-wifi"
									/>
								}
								onClick={() => this.onConnectSmallBusiness()}
								business
							/>
						</Col>
						<Col xs={12} sm={4} lg={4} md={4}>
							<BenefitCategory
								header={text.BUSINESS_BENEFIT_TO_NETWORK_OFFICES_TITLE}
								text={text.BUSINESS_BENEFIT_TO_NETWORK_OFFICES_TEXT}
								category={text.heroInternet}
								datatest="business_inoffice_button"
								icon={
									<span
										style={{
											fontSize: "48px",
											color: "#5812fe",
										}}
										className="icon48 icon-signal-2"
									/>
								}
								onClick={() => this.onConnectMediumBusiness()}
								business
							/>
						</Col>
						<Col xs={12} sm={4} lg={4} md={4}>
							<BenefitCategory
								header={text.BUSINESS_BENEFIT_TO_BUILDING_TITLE}
								text={text.BUSINESS_BENEFIT_TO_BUILDING_TEXT}
								category={text.heroInternet}
								datatest="business_inoffice_button"
								icon={
									<span
										style={{
											fontSize: "48px",
											color: "#5812fe",
										}}
										className="icon48 icon-antena-1"
									/>
								}
								onClick={() => this.onConnecBigBusiness()}
								business
							/>
						</Col>
					</Row>
				</Container>
			</Wrapper>
		);
	}
}
